import ApiService from 'services/ApiService';
import { IgetComplaintMessagesProps, IReplyComplaintMessageProps } from './types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
export const getComplaintMessages = createAsyncThunk(
  "order/complaint/messages",
  async ({
    token,
    orderId
  }: IgetComplaintMessagesProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let url = `/api/v1/order/complaint/message?order_id=${orderId}`;

      const response = await ApiService.get(url);
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        }
      } else {
        return {
          data: [],
          status: "empty",
          error: response.data?.message,
        }
      }
    } catch (err) {
      if (err) {
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        }
      }
    }
  }
)

export const sendComplainMessageReply = createAsyncThunk(
  "order/complaint/messages/reply",
  async ({orderId,senderName,role,message} : IReplyComplaintMessageProps) => {
    try {
      let url = `/api/v1/order/complaint/message?order_id=${orderId}`;
      const response = await ApiService.post(url,{
        senderName,
        role,
        message
      });
      return {
        data: [],
        status: "success",
        error: null,
      }
    } catch (err) {
      return Promise.reject(
        {
        data: [],
        status: "error",
        error: axios.isAxiosError(err) ? err.message : "Something went wrong!",
        }
      )
      // return {
      //   data: [],
      //   status: "error",
      //   error: axios.isAxiosError(err) ? err.message : "Something went wrong!",
      // }
    }
  }
)